<h1 mat-dialog-title class="dialog-title">{{ data.event ? "Event bearbeiten" : "Event erstellen" }}</h1>
<div mat-dialog-content class="event-dialog-content">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Titel</mat-label>
    <input matInput placeholder="z.B. Team Meeting" [(ngModel)]="eventTitle" />
  </mat-form-field>
  <!--Info: da eh nur der Tag als start in frage kommt, braucht man auch nur das Ende-->
  <!-- <mat-form-field>
    <input
      matInput
      [matDatepicker]="startPicker"
      placeholder="Start Date"
      [min]="eventStartDate"
      [max]="eventStartDate"
      [(ngModel)]="eventStartDate"
      disabled="true"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="startPicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #startPicker></mat-datepicker>
  </mat-form-field> -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>End-Datum</mat-label>
    <input
      matInput
      [matDatepicker]="endPicker"
      [(ngModel)]="eventEndDate"
      [min]="eventStartDate"
    />
    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
    <mat-datepicker #endPicker></mat-datepicker>
  </mat-form-field>
  <div class="time-row">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Start-Zeit</mat-label>
    <input
      matInput
      [format]="24"
      [(ngModel)]="eventStartTime"
      [ngxMatTimepicker]="startTimePicker"
      readonly
      (click)="startTimePicker.open()"
    />
    <mat-icon matSuffix (click)="startTimePicker.open()"> watch_later </mat-icon>
    <ngx-mat-timepicker #startTimePicker></ngx-mat-timepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>End-Zeit</mat-label>
    <input
      matInput
      [format]="24"
      [(ngModel)]="eventEndTime"
      [ngxMatTimepicker]="endTimePicker"
      readonly
      (click)="endTimePicker.open()"
    />
    <mat-icon matSuffix (click)="endTimePicker.open()"> watch_later </mat-icon>
    <ngx-mat-timepicker #endTimePicker></ngx-mat-timepicker>
    </mat-form-field>
  </div>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Kalender</mat-label>
    <mat-select [(ngModel)]="selectedCalendarId">
      <mat-option *ngFor="let option of calendarOptions" [value]="option.value">{{
        option.label
      }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button color="warn" class="dialog-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
    <span class="dialog-btn-label">Abbrechen</span>
  </button>
  <button mat-raised-button color="primary" class="dialog-btn" (click)="onAdd()" [disabled]="!eventTitle || !selectedCalendarId || !eventStartTime || !eventEndTime || !eventEndDate">
    <mat-icon>check</mat-icon>
    <span class="dialog-btn-label">{{ data.event ? "Speichern" : "Erstellen" }}</span>
  </button>
</div>
